import { z } from 'zod/v4';
import { DocumentTypeSchema } from '../../../document-types/contracts/schemas/document-type.js';

export const StyleDocumentSchema = z.object({
  id: z.string(),
  name: z.string(),
  fileId: z.string(),
  fileUrl: z.string().nullable(),
  documentTypeId: z.string(),
  documentClass: z.string().nullable(),
  documentType: DocumentTypeSchema,
  createdAt: z.coerce.date().nullable(),
  updatedAt: z.coerce.date().nullable(),
  isArchived: z.boolean(),
  metadata: z.record(z.string(), z.unknown()),
});

export type StyleDocumentType = z.infer<typeof StyleDocumentSchema>;
